import { isEqual } from 'lodash';

export const APIS_ADD_ACCESS = "APIS_ADD_ACCESS";
export const APIS_REMOVE_ACCESS = "APIS_REMOVE_ACCESS";

export const ORGANIZATIONS_ADD_ACCESS = "ORGANIZATIONS_ADD_ACCESS";
export const ORGANIZATIONS_REMOVE_ACCESS = "ORGANIZATIONS_REMOVE_ACCESS";


export const compareArrays = (arr1, arr2) => {
  if (arr1?.length !== arr2?.length) return true;

  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return !isEqual(sortedArr1, sortedArr2);
};